enum StepType {
  WarmUp = 'WARMUP',
  Exercise = 'EXERCISE',
  Rest = 'REST',
  Stretching = 'STRETCHING'
}

export default StepType
